<template>
  <div class="container p-mt-6">
    <h2 class="p-text-center p-mb-5">Ingreso Masivo y Relaciones</h2>
    <div class="p-grid p-justify-center">
      <!-- Opción 1: Ingreso Masivo de Videos -->
      <!--div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Videos"
          icon="pi pi-video"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivoVideos"
          disable="true"
        />
      </div-->

      <!-- Opción 2: Ingreso Masivo de Capítulos -->
      <!--div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Capítulos"
          icon="pi pi-book"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivoCapitulos"
        />
      </div-->

      <!-- Opción 3: Relación Video-Capítulo -->
      <!--div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Relación Video-Capítulo"
          icon="pi pi-link"
          class="p-button-raised p-button-info w-full"
          @click="irRelacionVideoCapitulo"
        />
      </div-->

      <!-- Opción 4: Ingreso Masivo de Preguntas -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Preguntas"
          icon="pi pi-question-circle"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivoPreguntas"
        />
      </div>


        <!-- Ingreso Masivo Alumnos -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Alumnos"
          icon="pi pi-user-plus"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivo"
        />
      </div>


      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Actualizo Masivo Casas"
          icon="pi pi-user-plus"
          class="p-button-raised p-button-success w-full"
          @click="irActualizoMasivoCasas"
        />
      </div>


       <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Apoderado"
          icon="pi pi-user-plus"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivoApoderado"
        />
      </div>

      <!-- Ingreso Masivo Profesor -->
      <div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Masivo Profesores"
          icon="pi pi-user-edit"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoMasivoProfesor"
        />
      </div>

      <!-- Ingreso Jefatura -->
      <!--div class="p-col-12 p-md-6 p-lg-3 p-mb-4">
        <ButtonPrime
          label="Ingreso Jefaturas"
          icon="pi pi-briefcase"
          class="p-button-raised p-button-success w-full"
          @click="irIngresoJefatura"
        />
      </div-->

    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'IngresoMasivoRelacion',
  setup() {
    const router = useRouter();




    const irActualizoMasivoCasas = () => {
      router.push({
        name: 'actualiza-masivo-casas-alumno'
      });
    };


    const irIngresoMasivo = () => {
      router.push({
        name: 'ingreso-masivo-alumno',
        query: {
          id_usuario: '3',
          tipo: 'alumno',
          cursos: '1,2,3,4,5,6,7,8,9,10,11,12',
        },
      });
    };

     const irIngresoMasivoApoderado = () => {
      router.push({
        name: 'ingreso-masivo-apoderado',
        query: {
          id_usuario: '3',
          tipo: 'alumno',
          cursos: '1,2,3,4,5,6,7,8,9,10,11,12',
        },
      });
    };

    const irIngresoMasivoProfesor = () => {
      router.push({
        name: 'ingreso-masivo-profesor',
        query: {
          id_usuario: '3',
          tipo: 'profesor',
          cursos: '1,2,3,4,5,6,7,8,9,10,11,12',
        },
      });
    };

    const irIngresoJefatura = () => {
      router.push({ name: 'ingreso-jefaturas' });
    };

    const irIngresoMasivoVideos = () => {
      router.push({ name: 'ingreso-masivo-videos' });
    };

    const irIngresoMasivoCapitulos = () => {
      router.push({ name: 'ingreso-masivo-capitulos' });
    };

    const irRelacionVideoCapitulo = () => {
      router.push({ name: 'relacion-video-capitulo' });
    };

    const irIngresoMasivoPreguntas = () => {
      router.push({ name: 'ingreso-preguntas-nuevo' });
    };

    return {
      irIngresoMasivoVideos,
      irIngresoMasivoCapitulos,
      irRelacionVideoCapitulo,
      irIngresoMasivoPreguntas,
      irIngresoMasivoProfesor, irIngresoJefatura, irIngresoMasivo, irIngresoMasivoApoderado, irActualizoMasivoCasas
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
}

.w-full {
  width: 100%;
}

.p-button-raised {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.2s;
}

.p-button-raised:hover {
  transform: translateY(-2px);
}

.p-text-center {
  color: #333;
  font-weight: 600;
}

@media (max-width: 768px) {
  .p-grid {
    flex-direction: column;
    align-items: center;
  }
}
</style>